<template>
  <div v-if="!readOnly">
    <span class="subtitle-2"><v-icon left>mdi-paperclip</v-icon> Proof of Payment (Optional)</span>
    <p class="caption">Click below or drag a file into the box to add an attachment</p>
    <v-progress-linear
      v-if="uploadPercentage > 0 || loading"
      :value="uploadPercentage"
      :indeterminate="uploadPercentage === 100 || loading"
    ></v-progress-linear>
    <media-field style="min-height: 100px;" @updated="onMediaUpdate" @uploadPercentage="onUploadPercentage">
      <media-drop-zone>
        <v-chip v-for="item in items" :key="item.id" small class="ma-2" close @click.stop="onClickDownloadButton(item)" @click:close="onClickDeleteButton(item)">
          {{ item.media.filename }}
        </v-chip>
      </media-drop-zone>
    </media-field>

    <a @click.prevent="onClickAddFile">Media Library</a>
    <media-popup model-name="media" @selected="onMediaUpdate" ref="media_popup" />
    <delete-dialog
      object-name="attachment"
      :open="deleteConfirmOpen"
      @cancelled="onConfirmCancelled"
      @deleted="onConfirmDeleteDeleted"
    />
  </div>
  <!--- Read only template ---->
  <div v-else>
    <v-skeleton-loader v-if="loading" :loading="loading" type="chip"></v-skeleton-loader>
    <v-chip
      v-for="item in items"
      :key="item.id"
      close-icon="mdi-download"
      small
      class="ma-2"
      close
      @click:close.stop="onClickDownloadButton(item)"
    >
      {{ item.media.filename }}
    </v-chip>
  </div>
</template>

<script>


import {ADD_MESSAGE} from "@/store/mutation-types";

import DeleteDialog from "@/components/DeleteDialog.vue";
import MediaDropZone from "@/components/media/MediaDropZone.vue";
import MediaPopup from "@/components/media/MediaPopup.vue";
import MediaField from "@/components/media/MediaField.vue";

import downloadMixin from "@/mixins/download";
import eventHub from "@/event-hub.js";

export default {
  name: "ProofOfPayment",

  components: { DeleteDialog, MediaPopup, MediaField, MediaDropZone },

  mixins: [downloadMixin],

  props: {
    submissionId: { type: Number },
    readOnly: { type: Boolean, default: true }
  },

  data() {
    return {
      loading: false,
      idDeleteItem: -1,
      deleteConfirmOpen: false,
      items: [],
      formObject: null,
      uploadPercentage: 0,
      formNew: {
        media: {}
      }
    };
  },

  computed: {
    submissionIdIsSet() {
      return !!this.submissionId;
    },
    mediaUrl() {
      return `/inspection/submissions/${this.submissionId}/proofs-of-payment/`;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {
    submission: {
      handler(value) {
        if (value && value.id) {
          this.fetchItems();
        } else {
          this.items = [];
        }
      }
    }
  },

  mounted() {
    if (this.submissionIdIsSet) {
      this.fetchItems();
    }
  },

  methods: {
    async fetchItems() {
      this.loading = true;
      const response = await this.$http.get(this.mediaUrl);
      this.loading = false;
      this.items = response.data;
    },

    async onItemsUpdated() {
      await this.fetchItems();
      this.formObject = null;
    },

    onItemClick(item) {
      this.formObject = { ...item };
    },

    onClickDeleteButton(item) {
      this.deleteConfirmOpen = true;
      if (typeof item.id == "number") {
        this.idDeleteItem = item.id;
      }
    },

    onClickDownloadButton(item) {
      this.downloadResource(item.media.file || "", item.media.filename || "");
    },

    onConfirmCancelled() {
      this.idDeleteItem = -1;
      this.deleteConfirmOpen = false;
    },

    async onConfirmDeleteDeleted() {
      await this.sendDelete(this.idDeleteItem);
      await this.fetchItems();
      this.idDeleteItem = -1;
      this.deleteConfirmOpen = false;
      this.showSnackbarSuccess();
    },

    async sendDelete(id) {
      await this.$store.dispatch("proofOfPayment/delete", id);
    },

    async onMediaUpdate(item) {
      this.uploadPercentage = 0;
      const attachment = {
        media: item.id,
        submission: this.submissionId
      };
      try {
        const response = await this.$store.dispatch("proofOfPayment/create", attachment);
        this.items = [...[response.data], ...this.items];
        this.$refs.media_popup.close();
      } catch (error) {
        this.$store.commit(`theme/${ADD_MESSAGE}`, { text: "Could not attach the file", type: "error" });
      }
    },

    onClickAddFile() {
      this.$refs.media_popup.open();
    },

    onUploadPercentage(value) {
      this.uploadPercentage = value;
    },

    onClickDropArea() {
      eventHub.$emit("clickMediaUpload");
    },

    showSnackbarSuccess() {
      this.$store.commit(`theme/${ADD_MESSAGE}`, { type: "success", text: "Success" });
    }
  }
};
</script>

<style scoped></style>
